import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {MerchantButton} from "../../../../common/MerchantButton";
import {apiDeleteAddress, UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {Controller} from "../../../flows/Controller.js";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {Toast} from "../../../../ui/Toast.jsx";


@autoredraw(UserAddressStore)
export class InlineUserDashboardRemoveAddressPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeAddress,
        };
    }

    @wrapInSpinner
    async removeAddress() {
        await apiDeleteAddress(Controller.address.selectedAddress.id);
        Router.back();
        Toast.showSuccess(Messages.addressRemoved);
    }

    render() {
        const {styleSheet} = this;

        return [
            <MessageElement message={Messages.deleteAddressDescription(Controller.address.selectedAddress.toString())}/>,
            <MerchantButton className={styleSheet.actionButton} label={Messages.remove} onClick={() => this.removeAddress()}/>,
            <div className={styleSheet.backButton} onClick={() => Router.back()}>
                {Messages.cancel}
            </div>
        ];
    }
}
